// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"StepByStep_iconWrapper__33NFT","icon":"StepByStep_icon__3XMeI","tile":"StepByStep_tile__3MaGC"};